import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Keep the browser chrome (iOS Safari address bar / Android status bar)
// tinted to the active page theme — black by default, light when the
// visitor flips a public page to light.
(() => {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (!meta || typeof MutationObserver === "undefined") return;
  const sync = () => {
    const t = document.documentElement.getAttribute("data-cryptpe-theme");
    meta.setAttribute("content", t === "light" ? "#fafafa" : "#000000");
  };
  new MutationObserver(sync).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-cryptpe-theme"],
  });
  sync();
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
